"use client";

import { FC } from "react";
import { gapClassMap } from "apps/website/maps/Flex.map";
import { rotationMap } from "apps/website/maps/Rotation.map";
import { themeRootClassMap } from "apps/website/maps/Theme.map";
import cx from "apps/website/utils/misc/cx";

import TextControl from "../../base/Text/TextControl/TextControl";
import TextTitle from "../../base/Text/TextTitle/TextTitle";
import Grid from "../../layout/Grid/Grid";
import Column from "../../layout/Column/Column";
import TextBody from "../../base/Text/TextBody/TextBody";
import Image from "../../base/Image/Image";
import HorizontalIconTextList from "../../feature/HorizontalIconTextList/HorizontalIconTextList";
import {
  IHorizontalIconTextListItem,
} from "../../feature/HorizontalIconTextList/HorizontalIconTextListItem/HorizontalIconTextListItem";
import Section from "../../layout/Section/Section";

export interface ISectionKatKinDifferenceProps {
  title?: string;
  subtitle?: string;
  tagText?: string;
}

const katkinDifferenceReasons: IHorizontalIconTextListItem[] = [
  {
    title: "Human-grade ingredients",
    body: "Only 100% real meat or fish. So fresh your picky carnivore can’t refuse.",
    icon: "otherMeat",
    spans: { default: 12, lg: 4 },
  },
  {
    title: "Gently steam-cooked",
    body: "Locks in flavour and preserves the natural bite and texture of meat.",
    icon: "otherSteamed",
    spans: { default: 12, lg: 4 },
  },
  {
    title: "Optimised nutrition",
    body: "Our in-house vet team formulates a custom nutrient mix for every recipe, so it’s complete + balanced.",
    icon: "treatsCircled",
    pills: [ "Vitamin B12", "Calcium", "Zinc", "Taurine" ],
    spans: { default: 12, lg: 4 },
  },

];

const SectionKatKinDifference: FC<ISectionKatKinDifferenceProps> = ({ title, subtitle, tagText }) => (
  <Section component={SectionKatKinDifference.name} className="px-4">
    <Grid gap="lg">
      <Column spans={{ default: 12, lg: 6 }} justify="center" align={{ default: "center", lg: "start" }} className="lg:pl-8">
        { tagText && (
          <div
            className={cx("flex w-fit justify-center lg:justify-start items-center px-2 mb-4", themeRootClassMap["brand-alt"], rotationMap[-1], gapClassMap[2])}>
            <TextControl align="center" size={1}>{ tagText }</TextControl>
          </div>) }
        { title && (
          <TextTitle size={1} className="normal-case mb-4 text-center lg:text-left">
            { title }
          </TextTitle>
        ) }
        { subtitle && (
          <TextBody size={1} className="mb-6 text-center lg:text-left">
            { subtitle }
          </TextBody>
        ) }
      </Column>
      <Column spans={{ default: 12, lg: 6 }} align="center">
        <Image className="lg:px-4 lg:pb-8" image={{ src: "/images/landingPage/Fussiness/recipe-image-desktop.png", responsiveSrc: { mobile: "/images/landingPage/Fussiness/recipe-image-mobile.png", desktop: "/images/landingPage/Fussiness/recipe-image-desktop.png" }, width: 686, height: 686 }} advancedImages={{ desktop: { src: "/images/landingPage/Fussiness/recipe-image-desktop.png", width: 1432, height: 975 } }} alt={""}></Image>
      </Column>
      <Column spans={{ default: 12, lg: 10 }} offset={{ lg: 2 }}>
        <HorizontalIconTextList items={katkinDifferenceReasons}></HorizontalIconTextList>
      </Column>
    </Grid>
  </Section>
);

export default SectionKatKinDifference;
